import React from 'react';

function Help() {
    return (
        <div>
            <span>If you have any questions or need help with MetaDB, please contact us by email <a href="https://gmail.com" target="_blank">MetaDBChess@gmail.com</a></span>
        </div>
    );
}

export default Help;